
import Vue from 'vue'

export default Vue.extend({
    props: {
        item: Object as () => (Connex.VM.Event & Partial<Connex.Thor.Filter.WithMeta>),
        index: Number
    },
    data: () => {
        return {
            view: 'raw' as 'raw' | 'decoded',
            decodedViewCreated: false
        }
    },
    computed: {
        isDecodable(): boolean { return this.item.topics.length > 0 }
    },
    watch: {
        view(newVal) {
            if (newVal === 'decoded') {
                this.decodedViewCreated = true
            }
        }
    }
})
